import { ReactNode, FC } from 'react';
import * as S from './ServiceCard.styled';
import { ReactComponent as InfoIcon } from 'assets/information.svg';

export type InfoCardProps = {
    icon?: ReactNode;
    title: ReactNode;
    description: ReactNode;
    rightContent?: ReactNode;
};

export const InfoCard: FC<InfoCardProps> = ({
    title,
    description,
    icon,
    rightContent
}) => {
    return (
        <S.InfoCardWrapper>
            <S.No>{icon ?? <InfoIcon />}</S.No>
            <S.ServiceCardText>
                <S.ServiceCardTitle>{title}</S.ServiceCardTitle>
                <S.ServiceCardDescription>
                    {description}
                </S.ServiceCardDescription>
            </S.ServiceCardText>
            {rightContent && (
                <S.ServiceCardPrice>{rightContent}</S.ServiceCardPrice>
            )}
        </S.InfoCardWrapper>
    );
};
